module.exports = __webpack_public_path__ + "static/media/21.7128a64e.mp3";